import { SkeletonBox } from '@/components/SkeletonBox'
import { useMaxWidthBreakpoint } from '@sevenrooms/ui-kit/hooks'
import { ExperiencesContainer } from './ExperiencesContainer'
import type { ExperienceCardProps } from '@/Reservations/Search/ExperienceCard'

const SKELETON_BOX_HEIGHT = '289px'

export interface ExperiencesSkeletonProps {
  desktopVariant?: ExperienceCardProps['variant']
}

export function ExperiencesSkeleton({ desktopVariant = 'full' }: ExperiencesSkeletonProps) {
  const isSmallBreakpoint = useMaxWidthBreakpoint('s')
  const columnsCount = isSmallBreakpoint || desktopVariant === 'full' ? 1 : 2
  return (
    <ExperiencesContainer columnsCount={columnsCount}>
      <SkeletonBox height={SKELETON_BOX_HEIGHT} />
      <SkeletonBox height={SKELETON_BOX_HEIGHT} />
    </ExperiencesContainer>
  )
}
